export default __webpack_public_path__ + "static/The_crown_estate_blue-3781ca2211f229cb335cb1d368ae8566.png";